// extracted by mini-css-extract-plugin
export var backdropBlur = "_d3-0";
export var contentCard = "_d3-5";
export var frame = "_d3-2";
export var image = "_d3-4";
export var imagePane = "_d3-3";
export var modal = "_d3-1";